<template>
  <div class="bottom m_flex_box flex_vc flex_hc flex_v">
    <div><img src="@/assets/login/页面底部logo.png"></div>
    <div class="titleEng">{{$t('深红未来(深圳)科技有限公司')}}</div>
    <div class="titleEng">Deep Red Future Technology Co. Ltd., Shenzhen</div>
    <div class="titleEng">{{$t('苏ICP备2025171803号-1')}}</div>
  </div>
</template>

<script>
  export default {

    data() {
      return{

      }
    },
    created() {
    },
    mounted(){

    },
    methods:{

    }
  }
</script>

<style scoped lang="scss">
  .bottom{
    height: 170px;
    background-color: #131921;
    color: #fff;
    text-align: center;
    .titleEng{
      margin-bottom: 10px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Bottom.vue